export default __webpack_public_path__ + "projects-features.png";